var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSchoolIconWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.431 15.8998H25.154V14.4945C25.1536 14.2892 25.0427 14.1 24.8638 13.9995L17.069 9.61845V7.3881H18.6109V8.23586C18.6109 8.55007 18.8656 8.80483 19.1798 8.80483H23.8283C24.1425 8.80469 24.3971 8.54986 24.397 8.23565C24.397 8.16979 24.3855 8.10443 24.3631 8.04241L23.8966 6.71672L24.3688 5.41948C24.4756 5.12398 24.3227 4.79782 24.0272 4.69099C23.9653 4.66859 23.8999 4.65714 23.834 4.65707H21.7174V3.83207C21.7174 3.51786 21.4627 3.2631 21.1484 3.2631H17.069V2.56897C17.069 2.25475 16.8142 2 16.5 2C16.1858 2 15.931 2.25475 15.931 2.56897V9.61845L8.13621 13.9938C7.95727 14.0944 7.84639 14.2835 7.84603 14.4888V15.8941H0.568965C0.254754 15.8941 0 16.1489 0 16.4631V31.3472C0 31.6615 0.254754 31.9162 0.568965 31.9162H32.431C32.7452 31.9162 33 31.6615 33 31.3472V16.4688C33 16.1546 32.7452 15.8998 32.431 15.8998ZM21.7174 6.81914L21.6947 6.79638V5.81776H22.9919L22.7586 6.54603C22.712 6.67277 22.712 6.81188 22.7586 6.93862L23.026 7.6669H19.7488V7.3881H21.1484C21.4627 7.3881 21.7174 7.13335 21.7174 6.81914ZM17.069 4.40103H20.5795V5.24879V6.25017H17.069V4.40103ZM7.84603 30.7783H1.13793V17.0378H7.84603V30.7783ZM15.931 30.7783H12.944V24.2807H15.931V30.7783ZM20.056 30.7783H17.069V24.2807H20.056V30.7783ZM24.0388 30.7783H21.194V23.7117C21.194 23.3975 20.9392 23.1428 20.625 23.1428H12.375C12.0608 23.1428 11.806 23.3975 11.806 23.7117V30.7783H8.96121V14.8472L16.5 10.6028L24.016 14.8245L24.0388 16.4631V30.7783ZM31.8621 30.7783H25.154V17.0378H31.8621V30.7783Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4997 11.8857C15.1821 11.8889 14.1157 12.9578 14.1157 14.2754C14.1189 15.5921 15.1887 16.6568 16.5054 16.6537C17.822 16.6505 18.8868 15.5807 18.8837 14.264C18.8805 12.9496 17.8141 11.8857 16.4997 11.8857ZM16.4997 15.5157C15.8115 15.5126 15.2562 14.9522 15.2593 14.264C15.2625 13.5803 15.8159 13.0268 16.4997 13.0237C17.1888 13.0268 17.7457 13.5863 17.7457 14.2754H17.7514C17.7483 14.9636 17.1879 15.5189 16.4997 15.5157Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.64721 17.8315H2.50928V20.1074H3.64721V17.8315Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.4519 17.8315H5.31396V20.1074H6.4519V17.8315Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9663 17.8315H10.6904V18.9695H12.9663V17.8315Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6382 17.8315H15.3623V18.9695H17.6382V17.8315Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3091 17.8315H20.0332V18.9695H22.3091V17.8315Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9663 20.4829H10.6904V21.6208H12.9663V20.4829Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6382 20.4829H15.3623V21.6208H17.6382V20.4829Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3091 20.4829H20.0332V21.6208H22.3091V20.4829Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M3.64721 22.3091H2.50928V24.5849H3.64721V22.3091Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M6.4519 22.3091H5.31396V24.5849H6.4519V22.3091Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M3.64721 26.7925H2.50928V29.0683H3.64721V26.7925Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M6.4519 26.7925H5.31396V29.0683H6.4519V26.7925Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6858 17.8315H26.5479V20.1074H27.6858V17.8315Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M30.491 17.8315H29.353V20.1074H30.491V17.8315Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6858 22.3091H26.5479V24.5849H27.6858V22.3091Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M30.491 22.3091H29.353V24.5849H30.491V22.3091Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6858 26.7925H26.5479V29.0683H27.6858V26.7925Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M30.491 26.7925H29.353V29.0683H30.491V26.7925Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchoolIconWhite);
export default __webpack_public_path__ + "static/media/SchoolIconWhite.c95f9b59dfcc1abfd9cda88dd874fc7f.svg";
export { ForwardRef as ReactComponent };